<template>
    <v-container class="elevation-0" :style="'opacity: 1.0;height:180px;border:0px solid red;padding:0;margin:0;color:'+fontColor+';'">

                <v-row justify="center" style="margin:0;padding:0;">
                    <v-col cols="12" sm="12" md="9" lg="9" xl="9" justify="center" align="center"
                        style="margin:0;padding:0;">

                        <v-row>
                            <v-tabs
                                v-model="tab"
                                align-tabs="center"
                            >
                                <v-tab value="1">
                                    Search
                                </v-tab>
                                <v-tab value="2">
                                    Upload File
                                </v-tab>
                                <v-tab value="3">
                                    Advanced Options
                                </v-tab>
                            </v-tabs>
                        </v-row>
                        <v-row style="padding:0;margin:0;">
                            <v-col cols="12" sm="12" md="12" lg="12" xl="12" justify="center" align="center">
                                <div style="">
                                    <v-window v-model="tab">
                                        <v-window-item value="1">
                                            <div style="height:10px;"></div>
                                            <v-row style="padding:0;margin:0;">
                                                <v-col cols="12" sm="12" md="9" lg="9" xl="9" justify="center" align="center" style="margin:0;padding:0;">
                                                    <v-table style="margin:0;margin-right:20px;padding:0;">
                                                        <tr>
                                                            <td style="width:15px;">
                                                                <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                                    id="icon-pp2-hdiv-p" @click="showTooltip('icon-pp2-hdiv-p', 'search-info')" />
                                                            </td><td>
                                                                <v-text-field id="qform" :style="'width:100%;margin:0px;padding:0px;color:'+fontColor+';'"
                                                                    class="input-form-light" v-model="variantlisttext" ref="qform" solo label="TP53:p.R282W"
                                                                    clearable v-on:update="inputUpperCase($event)"
                                                                    hint="Search for a cancer variant or gene by entering a gene name and variant exchange
                                                                        (e.g. 'TP53:p.R282W'), a genomic location ('chr7:140753336A>T') or a gene fusion
                                                                        ('chr7:47408367-chrX:66863099')"
                                                                    @keyup.enter="startSearch()"
                                                                >
                                                                </v-text-field>
                                                            </td>
                                                        </tr>
                                                    </v-table>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="3" lg="3" xl="3" justify="center" align="center" style="margin:0;padding:0;">
                                                    <v-select @update:modelValue="updateRefGenome" v-model="refgen.id"
                                                        :items="ref_genomes"
                                                        label="Reference genome" item-title="name" item-value="id" solo
                                                        :style="'color:'+fontColor+';'"
                                                        >
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row style="padding:0;margin:0;margin-bottom:30px;border:0px solid red;padding:0;">
                                                <v-col cols="12" sm="12" md="12" lg="12" xl="12" style="margin:0;padding:0;" justify="center"
                                                    align="center">
                                                    <div style="margin:auto;padding-top:0px;">
                                                        <v-btn style="text-align: center; margin-right: 8px !important;" v-on:click="loadSampleData()" >
                                                            Load sample
                                                        </v-btn>
                                                        <v-btn color="info" v-on:click="startSearch()">
                                                            Search
                                                        </v-btn>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-window-item>
                                        <v-window-item value="2">
                                            <UploadFiles></UploadFiles>
                                        </v-window-item>
                                        <v-window-item value="3">
                                            <v-table :style="'width:100%;padding:5px;background-color:'+backgroundColor+';color:'+fontColor+';'" density="compact">
                                                <tr>
                                                    <td>Cancer type
                                                        <span style="margin-left:10px;">
                                                                    <v-btn
                                                                      :disabled="dialog"
                                                                      icon="mdi-comment-alert-outline"
                                                                      text="Start loading"
                                                                      @click="dialog = true"
                                                                      size="x-small"
                                                                    ></v-btn>

                                                                    <v-dialog
                                                                      v-model="dialog"
                                                                      max-width="420"
                                                                      persistent
                                                                    >
                                                                      <v-list
                                                                        class="py-2"
                                                                        color="primary"
                                                                        elevation="4"
                                                                        rounded="lg"
                                                                      >
                                                                        <v-list-item
                                                                          prepend-icon="$vuetify-outline"
                                                                          title="Select the cancer type of your data"
                                                                        >
                                                                          <template v-slot:prepend>
                                                                            <div class="pe-4">
                                                                              <v-icon color="primary" size="x-large"></v-icon>
                                                                            </div>
                                                                          </template>

                                                                          <template v-slot:append>
                                                                              <v-btn
                                                                                class="ms-auto"
                                                                                text="Ok"
                                                                                @click="dialog = false"
                                                                              ></v-btn>
                                                                            </template>

                                                                        </v-list-item>
                                                                      </v-list>
                                                                    </v-dialog>

                                                        </span>
                                                    </td>
                                                    <td style="width:80%;">
                                                        <v-select
                                                            @update:modelValue="selectTumorType"
                                                            v-model="tumortypes.name"
                                                            :items="$store.getters.tumorTypes">
                                                            </v-select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>OncoKB Key
                                                        <span>
                                                        <v-btn
                                                                      :disabled="dialog_onco"
                                                                      icon="mdi-comment-alert-outline"
                                                                      text="Start loading"
                                                                      @click="dialog_onco = true"
                                                                      size="x-small"
                                                                    ></v-btn>

                                                                    <v-dialog
                                                                      v-model="dialog_onco"
                                                                      max-width="600"
                                                                      persistent
                                                                    >
                                                                      <v-list
                                                                        class="py-2"
                                                                        color="primary"
                                                                        elevation="4"
                                                                        rounded="lg"
                                                                      >
                                                                        <v-list-item
                                                                          prepend-icon="$vuetify-outline"
                                                                          title="Enter an OncoKB token to include clinical significance data from the OncoKB API in the Onkopus results.
                                                                To retrieve a key, register an account at https://www.oncokb.org"
                                                                        >
                                                                          <template v-slot:prepend>
                                                                            <div class="pe-4">
                                                                              <v-icon color="primary" size="x-large"></v-icon>
                                                                            </div>
                                                                          </template>

                                                                          <template v-slot:append>
                                                                              <v-btn
                                                                                class="ms-auto"
                                                                                text="Ok"
                                                                                @click="dialog_onco = false"
                                                                              ></v-btn>
                                                                            </template>

                                                                        </v-list-item>
                                                                      </v-list>
                                                                    </v-dialog>




                                                            <!--<v-icon icon="mdi-comment-alert-outline" @click="showOncoKBTip = !showOncoKBTip">
                                                            </v-icon>
                                                            <v-tooltip v-model="showOncoKBTip" activator="parent" location="top">
                                                                Enter an OncoKB token to include clinical significance data from the OncoKB API in the Onkopus results.
                                                                To retrieve a key, register an account at https://www.oncokb.org
                                                            </v-tooltip>-->
                                                        </span>
                                                    </td>
                                                    <td style="width:80%;">
                                                        <v-text-field label="Enter a custom OncoKB key" v-model="oncokbkey"
                                                            v-on:update="inputUpperCase($event)">
                                                        </v-text-field>
                                                    </td>
                                                </tr>

                                            </v-table>
                                        </v-window-item>
                                    </v-window>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="3" xl="3" align="center" justify="center"
                        style="padding-top:0;">

                    </v-col>
                </v-row>

    </v-container>
</template>
<script>
import UploadFiles from '@/components/query_components/UploadFiles';
import variant_annotation from "@/methods/variant_annotation";
import useTooltip from '@/methods/tooltip.js';
import tumor_types from "@/methods/tumor_types";

export default {
    name: 'upload-files',
    components: {
        UploadFiles
    },
    data: function () {
        return {
            dialog: false,
            dialog_onco: false,
            variantlisttext: '',
            oncokbkey: '',
            upload_file_title: "Upload file",
            refgen: { id: "hg38", name: "hg38 / GRCh38" },
            ref_genomes: [
                {
                    id: "hg38",
                    name: "hg38 / GRCh38"
                },
                {
                    id: "hg19",
                    name: "hg19 / GRCh37"
                },
                {
                    id: "t2t",
                    name: "T2T-CHM13"
                }
            ],
            tumortypes: [
                {
                    id:"",
                    name:""
                }
            ],
            open: ['upload-file'],
            openSearch: ['search-biomarker'],
            props: {
                item: {}
            },
            uploadFileOpen: false,
            showOncoKBTip: false,
            tab: null,
        }
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 4000)
      },
      dialog_onco (val) {
        if (!val) return

        setTimeout(() => (this.dialog_onco = false), 4000)
      },
    },
    methods: {
        async selectTumorType(val) {
            this.tumortypes.name = val
            this.$store.dispatch('setSelectedTumorType',val)
        },
        showTooltip(element_id, tooltip_id, tooltip_title = undefined) {
            useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
        },
        startSearch() {
            this.$store.dispatch('clearAGG');
            this.$store.dispatch('setAGGShown', {table_id: '$all', show_grid: false});
            this.setSessionParameters()

            this.$store.dispatch('setSNVs', {})
            this.$store.dispatch('setIns', {})
            this.$store.dispatch('setDels', {})
            this.$store.dispatch('setCNVs', {})
            this.$store.dispatch('setFusions', {})

            // set OncoKB key
            //alert(this.oncokbkey)

            this.$store.dispatch('setProcessState', ["load-results", '<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden" style="padding-top:20px;font-size:14px;">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>'])

            this.$router.push(this.$store.getters.getRouterBaseURL + '/upload/show-variant-interpretation-results-q?q=' + this.variantlisttext + '&genome_version=' + this.$store.getters.getGenomeVersion + '&tumor_type=' + encodeURIComponent(this.$store.getters.selectedTumorType))
            this.$store.dispatch('setProcessState', ['load-results', ''])
        },
        loadSampleData() {
            this.$store.dispatch('clearAGG');
            this.$store.dispatch('setAGGShown', {table_id: '$all', show_grid: false});
            this.$router.push(this.$store.getters.getRouterBaseURL + '/upload/show-variant-interpretation-results-q?q=sample')
        },
        updateRefGenome(val) {
            //print("update "+val)
            if (val == "hg38") {
                this.refgen = this.ref_genomes[0]
            } else if (val == "hg19") {
                this.refgen = this.ref_genomes[1]
            } else if (val == "t2t") {
                this.refgen = this.ref_genomes[2]
            }
            this.$store.dispatch('setGenomeVersion', val)
        },
        setSessionParameters() {
            this.$store.dispatch('setOncoKBKey', this.oncokbkey)
            localStorage.setItem("oncokbKey", this.oncokbkey)
        },
    },
    mounted: async function () {

        // format file upload form
        this.open = []

        // set OncoKB key
        if (localStorage.getItem("oncokbKey") === null) {
            this.oncokbkey = ""
        } else {
            this.oncokbkey = localStorage.getItem("oncokbKey")
        }

        // set genome version
        if (this.$route.query.genome_version) {
            this.updateRefGenome(this.$route.query.genome_version)
        }
        if (!this.$store.getters.getGenomeVersion) {
            this.$store.dispatch("setGenomeVersion", "hg38")
        }

        // set cancer type
        if (this.$route.query.tumor_type) {
            this.selectTumorType(this.$route.query.tumor_type)
        }

        //this.$store.dispatch('setIdData',this.$route.params.id)
        if (this.$route.query.q) {
            if (this.$route.query.q == "sample") {
                this.variantlisttext = "TP53:p.R282W,GATA3:p.T421M,BRAF:p.V600E,BRCA2:p.P2204A,chr7:47368770-chrX:67643257"
            } else {
                this.variantlisttext = this.$route.query.q
            }
        } else {
            this.variantlisttext = ''
        }

        //const tumorTypes = tumor_types.getTumorTypes()
        const tumorTypes = ["Endometrial Cancer","Melanocytoma","Colorectal Cancer","Peripheral Nervous System","Uterine Sarcoma","Desmoplastic/Nodular Medulloblastoma","Non-Small Cell Lung Cancer","Thymic Tumor","Skin Cancer, Non-Melanoma","Malignant Glomus Tumor","Gestational Trophoblastic Disease","Parathyroid Cancer","Gastrointestinal Neuroendocrine Tumors of the Esophagus/Stomach","Myelodysplastic/Myeloproliferative Neoplasms","Breast Sarcoma","Esophageal/Stomach Cancer","Rhabdoid Cancer","Head and Neck Cancer","Adrenocortical Carcinoma","Soft Tissue Sarcoma","Medulloblastoma with Extensive Nodularity","Non-Hodgkin Lymphoma","Pancreatic Cancer","Eye Cancer","Nerve Sheath Tumor","Medulloblastoma","Peritoneal Cancer, NOS","Kidney Cancer","Mastocytosis","Lung Cancer","Malignant Rhabdoid Tumor of the Liver","Salivary Gland Cancer","Leukemia","Sex Cord Stromal Tumor","Posttransplant Lymphoproliferative Disorders","Liver Cancer","Undifferentiated Embryonal Sarcoma of the Liver","Primary CNS Melanocytic Tumors","Small Bowel Cancer","Ovarian Cancer","Soft Tissue Cancer","Appendiceal Cancer","Mature B-Cell Neoplasms","Penile Cancer","Myelodysplastic Syndromes","Sellar Tumor","Bladder/Urinary Tract Cancer","Vulvar Carcinoma","Gastrointestinal Stromal Tumor","Histiocytosis","Adenocarcinoma In Situ","Bowel Cancer","Tubular Adenoma of the Colon","Thyroid Cancer","T-Lymphoblastic Leukemia/Lymphoma","Uterine Cancer","CNS/Brain Cancer","Myofibromatosis","Pheochromocytoma","Ovarian/Fallopian Tube Cancer","Small Cell Lung Cancer","Ampullary Cancer","Embryonal Tumor","Mesothelioma","Hepatobiliary Cancer","Cancer of Unknown Primary","Lymphatic Cancer","Hodgkin Lymphoma","Miscellaneous Neuroepithelial Tumor","Angiomatoid Fibrous Histiocytoma","Infantile Fibrosarcoma","Renal Cell Carcinoma","Mature T and NK Neoplasms","Vaginal Cancer","Cervical Cancer","Melanoma","Myeloid Neoplasms with Germ Line Predisposition","B-Lymphoblastic Leukemia/Lymphoma","Clear Cell Sarcoma of Kidney","Sialoblastoma","Lymphatic Cancer, NOS","Pleural Cancer","Ampullary Carcinoma","Anal Cancer","Lacrimal Gland Tumor","Retinoblastoma","CNS Cancer","Esophagogastric Cancer","Testicular Cancer","Blastic Plasmacytoid Dendritic Cell Neoplasm","Blood Cancer","Germ Cell Tumor","Adrenal Gland Cancer","Blood Cancer, NOS","Skin Cancer","Choroid Plexus Tumor","Peripheral Nervous System Cancer","Other Cancer","Gastrointestinal Neuroendocrine Tumor","Adrenocortical Adenoma","Bladder Cancer","Vulvar/Vaginal Cancer","Breast Cancer","Miscellaneous Brain Tumor","Thymic Cancer","Pineal Tumor","Bone Cancer","Large Cell/Anaplastic Medulloblastoma","Myeloproliferative Neoplasms","Peritoneal Cancer","Glioma","Biliary Tract Cancer","Prostate Cancer","Wilms Tumor","Renal Neuroendocrine Tumor"]
        tumorTypes.sort()
        //alert(JSON.stringify(tumorTypes))
        this.$store.dispatch("setTumorTypes",tumorTypes)
    },
    created() {
        if (this.$route.params.id) {
            this.variantlisttext = ''
        }

        // get search bar tab
        if (this.$route.params.id) {
            this.tab = 1
        }

    }
}
</script>

<script setup>
import { useRoute } from 'vue-router'

var backgroundColor='#ffffff';
var fontColor='#000000';

if (!("/".localeCompare(useRoute().path) == -1)) {
       //backgroundColor = "#004476"
       //fontColor= '#ffffff'
       backgroundColor='#ffffff'
       fontColor = '#000000'
}

const emit = defineEmits(['clear-table']);

</script>
